import RoleFrame from "./frames/role"
import StudyFrame from "./frames/study"
import TaglineFrame from "./frames/tagline"

const FadeRightInAnimation = {
  loop: false,
  from: { opacity: 0, x: 100 },
  to: { opacity: 1, x: 0 },
  config: {
    duration: 500,
  }
}


export const aboutMeContent = [
  {
    content: <RoleFrame />,
    springConfig: FadeRightInAnimation,
    offset: 0,
  },

  {
    content: <StudyFrame />,
    springConfig: {delay: 300, ...FadeRightInAnimation},
    offset: 1,
  },
  
  {
    content: <TaglineFrame />,
    springConfig: FadeRightInAnimation,
    offset: 2,
  },
]